import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { GlobalService } from '../global/global.service';
import { TransferStoreService } from './transfer-store.service';

interface IFoundsOrigen {
  datos: { objectList: [] };
}

interface IFoundsDestination {
  datos: { objectList: [] };
}

interface IViaPay {
  datos: { viasDePagos: [] }
}

interface IRescue {
  datos: { rescate: [] }, resultado: [] 
}

@Injectable({
  providedIn: 'root',
})
export class TransferRequestsService {
  constructor(
    private http: HttpClient, 
    private globalService: GlobalService, 
    private router: Router,
    public transferStore: TransferStoreService,) {}


  getFoundsOrigen(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/transfer/private/listarFondosCuentaOrigen/${params.cuc}`)
      .pipe(map((apiResponse: IFoundsOrigen) => this.mapGetFoundsOrigen(apiResponse)));
  }

  getFoundsDestination(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/transfer/private/listarCuentaDestino/${params.cuc}`)
      .pipe(map((apiResponse: IFoundsDestination) => this.mapGetFoundsDestination(apiResponse)));
  }

  mapGetFoundsOrigen(apiResponse: { datos: { objectList: [] } } | any) {
    if(apiResponse && apiResponse.datos && apiResponse.datos.objectList){
      return apiResponse.datos.objectList;
    }
    return [];
  }

  mapGetFoundsDestination(apiResponse: { datos: { objectList: [] } } | any) {
    if(apiResponse && apiResponse.datos && apiResponse.datos.objectList){
      return apiResponse.datos.objectList;
    }
    return [];
  }

  mapGetFoundsDestinationCalcResc(apiResponse: { datos: { }} | any) {
    if(apiResponse && apiResponse.datos){
      return apiResponse.datos;
    }
    return [];
  }

  calcularTransferencia(params): Observable<any> {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/transfer/private/calcular/${params.numeroCuotas}/${params.idFondo}`)
    .pipe(map((apiResponse: IFoundsDestination) => this.mapGetFoundsDestinationCalcResc(apiResponse)));
  }

  validateTransferencia(params): Observable<any> {
    return this.http.post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/transfer/private/validarTransferencia`, params)
  }

  saveTransferencia(params): Observable<any> {
    return this.http.post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/transfer/private/grabarTransferencia`, params)
  }

  

  resetTransferenciaData() {
    this.transferStore.TRANSFER_FONDS= []
    this.transferStore.TRANSFER_FONDS_DESTINATION= []
    delete this.transferStore.TRANSFER_DATA
    delete this.transferStore.TRANSFER_CONFIRM_DATA
  }
}
